import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetStepLogIntegrationsRequest = App.Http.Requests.StepLog.GetStepLogIntegrationsRequest;
import GetStepLogIntegrationsResponse = App.Http.Responses.StepLog.GetStepLogIntegrationsResponse;
import GetStepLogIntegrationResponse = App.Http.Responses.StepLog.GetStepLogIntegrationResponse;
import GetStepLogIncomingPostbacksRequest = App.Http.Requests.StepLog.GetStepLogIncomingPostbacksRequest;
import GetStepLogIncomingPostbacksResponse = App.Http.Responses.StepLog.GetStepLogIncomingPostbacksResponse;
import GetStepLogIncomingPostbackResponse = App.Http.Responses.StepLog.GetStepLogIncomingPostbackResponse;
import GetStepLogOutgoingPostbacksResponse = App.Http.Responses.StepLog.GetStepLogOutgoingPostbacksResponse;
import GetStepLogOutgoingPostbackResponse = App.Http.Responses.StepLog.GetStepLogOutgoingPostbackResponse;
import GetStepLogOutgoingPostbacksRequest = App.Http.Requests.StepLog.GetStepLogOutgoingPostbacksRequest;
import GetStepLogStructuresRequest = App.Http.Requests.StepLog.GetStepLogStructuresRequest;
import GetStepLogStructuresResponse = App.Http.Responses.StepLog.GetStepLogStructuresResponse;
import GetStepLogStructureResponse = App.Http.Responses.StepLog.GetStepLogStructureResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

// ─── API class ────────────────────────────────────────────────────────────────

class StepLogApi extends TenantBaseApi {
    // Integration step logs — /step-logs/integrations

    async listIntegrationStepLogs(request: GetStepLogIntegrationsRequest): Promise<GetStepLogIntegrationsResponse> {
        return await this.get<GetStepLogIntegrationsResponse, GetStepLogIntegrationsRequest>(
            "/step-logs/integrations",
            { params: request }
        );
    }

    async getIntegrationStepLog(
        logId: string,
        request?: GetStepLogIntegrationsRequest
    ): Promise<GetStepLogIntegrationResponse> {
        return await this.get<GetStepLogIntegrationResponse, GetStepLogIntegrationsRequest>(
            `/step-logs/integrations/${logId}`,
            {
                params: request,
            }
        );
    }

    async exportIntegrationStepLogs(request?: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>(`/step-logs/integrations/export`, request);
    }

    // Incoming postback step logs — /step-logs/incoming-postbacks

    async listIncomingPostbackStepLogs(
        request: GetStepLogIncomingPostbacksRequest
    ): Promise<GetStepLogIncomingPostbacksResponse> {
        return await this.get<GetStepLogIncomingPostbacksResponse, GetStepLogIncomingPostbacksRequest>(
            "/step-logs/incoming-postbacks",
            {
                params: request,
            }
        );
    }

    async getIncomingPostbackStepLog(
        logId: string,
        request?: GetStepLogIncomingPostbacksRequest
    ): Promise<GetStepLogIncomingPostbackResponse> {
        return await this.get<GetStepLogIncomingPostbackResponse, GetStepLogIncomingPostbacksRequest>(
            `/step-logs/incoming-postbacks/${logId}`,
            { params: request }
        );
    }

    async exportIncomingPostbackStepLogs(request?: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>("/step-logs/incoming-postbacks/export", request);
    }

    // Outgoing postback step logs — /step-logs/outgoing-postbacks

    async listOutgoingPostbackStepLogs(
        request: GetStepLogOutgoingPostbacksRequest
    ): Promise<GetStepLogOutgoingPostbacksResponse> {
        return await this.get<GetStepLogOutgoingPostbacksResponse, GetStepLogOutgoingPostbacksRequest>(
            "/step-logs/outgoing-postbacks",
            {
                params: request,
            }
        );
    }

    async getOutgoingPostbackStepLog(
        logId: string,
        request?: GetStepLogOutgoingPostbacksRequest
    ): Promise<GetStepLogOutgoingPostbackResponse> {
        return await this.get<GetStepLogOutgoingPostbackResponse, GetStepLogOutgoingPostbacksRequest>(
            `/step-logs/outgoing-postbacks/${logId}`,
            { params: request }
        );
    }

    async exportOutgoingPostbackStepLogs(request?: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>("/step-logs/outgoing-postbacks/export", request);
    }

    // Structure step logs — /step-logs/structures

    async listStructureStepLogs(request: GetStepLogStructuresRequest): Promise<GetStepLogStructuresResponse> {
        return await this.get<GetStepLogStructuresResponse, GetStepLogStructuresRequest>("/step-logs/structures", {
            params: request,
        });
    }

    async getStructureStepLog(
        logId: string,
        request?: GetStepLogStructuresRequest
    ): Promise<GetStepLogStructureResponse> {
        return await this.get<GetStepLogStructureResponse, GetStepLogStructuresRequest>(
            `/step-logs/structures/${logId}`,
            { params: request }
        );
    }

    async exportStructureStepLogs(request?: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>("/step-logs/structures/export", request);
    }
}

export const stepLogApi = new StepLogApi();
